/* This example requires Tailwind CSS v2.0+ */
import { CurrencyDollarIcon, BuildingLibraryIcon } from '@heroicons/react/24/outline';
import { config } from '../config';
import Container from './Container';

const features = [
  {
    name: 'Lifetime secondary royalties',
    description: 'mOOfys primary sales and lifetime secondary royalties will be committed to The Gekofam & Friends Charity Wallet.',
    icon: CurrencyDollarIcon,
  },
  {
    name: '501c3 status',
    description: 'Gekofam & Friends Inc. is a registered 501(c)(3) nonprofit organization. Employer identification number (EIN) is 92-0395052.',
    icon: BuildingLibraryIcon,
  },
];

export default function CharityAbout() {
  return (
    <Container>
      <div className='pt-20 pb-0 md:pt-32'>
        <div className='mx-auto max-w-7xl sm:px-6 lg:px-8'>
          <div className='lg:text-center'>
            <p className='mt-2 text-3xl font-bold leading-8 tracking-tight text-gray-100 sm:text-4xl'>Our Mission</p>
            <p className='max-w-3xl mt-4 text-xl text-gray-500 lg:mx-auto'>
              Our current mission,{' '}
              <a href='https://goodwillncw.org/mlfv/' className='font-bold text-primary-500' target='_blank' rel='noreferrer'>
                The Miracle League of the Fox Valley
              </a>
              , gives children with disabilities the opportunity to play baseball at an accessible facility while building relationships, engaging
              socially with others and learning important life skills.
            </p>
          </div>

          <div className='mt-16'>
            <dl className='space-y-10 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10 md:space-y-0'>
              {features.map((feature) => (
                <div key={feature.name} className='relative'>
                  <dt>
                    <div className='absolute flex items-center justify-center w-12 h-12 rounded-md text-dropdown bg-primary-500'>
                      <feature.icon className='w-6 h-6' aria-hidden='true' />
                    </div>
                    <p className='ml-16 text-lg font-medium leading-6 text-gray-300'>{feature.name}</p>
                  </dt>
                  <dd className='mt-2 ml-16 text-base text-gray-500'>{feature.description}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>

        <div className='mt-24'>
          <p className='text-xl text-center text-text-darker'>
            Visit the{' '}
            <a href={config.discord} className='font-bold text-primary-500'>
              Gekofam Discord
            </a>{' '}
            for more info and updates. LFGeko!!!
          </p>
        </div>
      </div>
    </Container>
  );
}
